export const RestrictedWords: string[] = []; // All restricted words removed with the implementation of url delivery

export const DATE_DISPLAY_FORMAT = 'MMM D, YYYY';
